import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

import type { ServerConfig, User } from 'shared-types';

interface Params {
  serverConfig: Pick<ServerConfig, 'individualAchievementsUserAllow'>;
  user: Pick<User, 'id' | 'customAttributes' | 'email' | 'roles'>;
}

const isUserAllowedToRequestIndividualAchievements = ({
  serverConfig,
  user
}: Params) => {
  if (!serverConfig.individualAchievementsUserAllow.enabled) {
    return false;
  }
  if (
    !user?.roles.includes('superadmin') &&
    !attributesConditionsMatch({
      conditions: serverConfig.individualAchievementsUserAllow.conditions,
      customAttributeValues: user?.customAttributes,
      user: user
    })
  ) {
    return false;
  }
  return true;
};

export default isUserAllowedToRequestIndividualAchievements;
